import { batchEvents, setOneDSWriter } from './eventWriter';
import { setEventCreator } from './eventGenerator';


import { createClientError } from './creators/clientError';
import { createOutgoingRequest } from './creators/outgoingRequest';
import { createTrackedScenario } from './creators/trackedScenario';
import { flushEvents, initialize1DS, writeEvent as writeEvent1DS } from './IdentityUX.Shared.Telemetry/OneDSTelemetryInitializer';
import { ME } from '../utilities';

export {
    getPageTags,
    getTimeSince,
    createPartA,
    setEventCreator,
    fireEvent
} from './eventGenerator';
export { EventMoment, updateMoment, getCurrentAccountType } from './eventQueue';
export {
    addEventWriter,
    writeEvent,
    batchEvents,
} from './eventWriter';
export {
    flushEvents,
    initialize1DS
} from './IdentityUX.Shared.Telemetry/OneDSTelemetryInitializer';
export * from './utilities';

/** Set up initial event creators and writers */
export function setUpTelemetry(shouldBatch: boolean): void {
    // Setup the one DS writer to go along with the collection of writers so that both locations are have
    // all events written until it is decided to remove the old writers to Vortex.
    setOneDSWriter(writeEvent1DS);

    // Removed batching of events as the EventsAPI shared library has its own queing system.
    batchEvents(false);

    // Set initial event creators
    setEventCreator('ClientError', createClientError);
    setEventCreator('OutgoingRequest', createOutgoingRequest);
    setEventCreator('TrackedScenario', createTrackedScenario);
    
    if (ME?.Config?.enableTelemetry) {
        initialize1DS().then(() => {
            flushEvents();
        }).catch(()=>{
            // One retry to download script
            initialize1DS().then(()=>{
                flushEvents();
            });
        });
    }
}
